import { useContext } from 'react';
import { observer } from '@formily/reactive-react';
import { useField } from '@formily/react';
import type { VoidField } from '@formily/core';
import { FormTabsContext } from '../form-tabs/context';

export interface IFormTabPaneProps {
  tab: string;
  disabled?: boolean;
  style?: React.CSSProperties;
}

const FormTabPane = observer(({ children }: { children?: React.ReactNode }) => {
  const field = useField<VoidField>();
  const { activeKey } = useContext(FormTabsContext);

  return (
    <div
      style={{ display: field?.props?.name === activeKey ? 'block' : 'none' }}
    >
      {children}
    </div>
  );
});

export default FormTabPane;
